<template>
  <div style="width: 100%">
    <span class="title primary--text d-flex flex-wrap">
      <span style="white-space: nowrap;">Demandes d'</span>

      <span class="font-weight-bold" style="white-space: nowrap;">
        interventions
      </span>
    </span>
    <div v-if="activeDaughterId" class="font-italic warning--text title">
      Lien vers la fille :
      <link-to-request
        :request-id="activeDaughterId"
        :property-id="active.property_id"
      />
    </div>
    <div
      v-if="active && active.mother_request_id"
      class="font-italic warning--text title"
    >
      Lien vers la mère :
      <link-to-request
        :request-id="active.mother_request_id"
        :property-id="active.property_id"
        :daugther-id="activeId"
      />
    </div>
    <v-expansion-panels accordion flat v-model="panel" multiple>
      <display-expansion-panel class="border-bottom">
        <display-expansion-panel-header
          class="font-weight-bold text-uppercase px-0"
        >
          Informations
        </display-expansion-panel-header>
        <v-expansion-panel-content class="panel-pa-0">
          <request-infos :isRequestLogOpen="isRequestLogOpen" class="mb-2" />
          <attachment-menu :request-id="activeId" />
        </v-expansion-panel-content>
      </display-expansion-panel>
      <display-expansion-panel class="border-bottom">
        <display-expansion-panel-header
          class="font-weight-bold text-uppercase px-0"
        >
          Journal des actions
        </display-expansion-panel-header>
        <v-expansion-panel-content class="panel-pa-0">
          <request-logs-table />
        </v-expansion-panel-content>
      </display-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import RequestInfos from '@/pages/eDispatch/requestDetails/leftSide/RequestInfos';
import DisplayExpansionPanel from '@/components/displays/panels/DisplayExpansionPanel';
import DisplayExpansionPanelHeader from '@/components/displays/panels/DisplayExpansionPanelHeader';
import { createNamespacedHelpers } from 'vuex';
import RequestLogsTable from '@/pages/eDispatch/logs/RequestLogsTable';
import LinkToRequest from '@/components/tools/LinkToRequest';
import AttachmentMenu from '@/pages/eDispatch/requestsTable/AttachmentMenu';

const { mapGetters } = createNamespacedHelpers('requests');

export default {
  name: 'request-left-side',
  components: {
    RequestLogsTable,
    DisplayExpansionPanelHeader,
    DisplayExpansionPanel,
    RequestInfos,
    LinkToRequest,
    AttachmentMenu,
  },
  computed: {
    ...mapGetters(['activeId', 'activeDaughterId', 'active']),
    isRequestLogOpen() {
      return this.panel.includes(1);
    },
  },
  data: () => ({
    panel: [0],
  }),
  watch: {
    isRequestLogOpen(val) {
      this.$emit('requestLogsOpen', val);
    },
  },
  methods: {
    generateMessage,
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: solid 1px gray;
}
.panel-pa-0 >>> .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
